module.exports = __webpack_public_path__ + "static/media/n08.8eb3e54d.jpg";